import { render } from "./VisibProd.vue?vue&type=template&id=45819dee&scoped=true"
import script from "./VisibProd.vue?vue&type=script&lang=js"
export * from "./VisibProd.vue?vue&type=script&lang=js"

import "./VisibProd.vue?vue&type=style&index=0&id=45819dee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45819dee"]])

export default __exports__